import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9daa650a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "admin-icon-input-group" };
const _hoisted_2 = { class: "icon-preview-wrapper" };
const _hoisted_3 = { class: "form" };
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AdminIconComponentVariableRawValue',
    props: {
        modelValue: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const isString = (value) => {
            return typeof value === "string";
        };
        const modelValueProxy = computed({
            get: () => (isString(props.modelValue) ? props.modelValue : ""),
            set: (value) => {
                emit("update:modelValue", value || undefined);
            },
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("i", {
                        class: _normalizeClass(_ctx.modelValue || 'far fa-question-circle icon-placeholder')
                    }, null, 2 /* CLASS */)
                ]),
                _createElementVNode("form", _hoisted_3, [
                    _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((modelValueProxy).value = $event)),
                        placeholder: "Enter FontAwesome class (e.g., far fa-user)",
                        class: "icon-class-input"
                    }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, modelValueProxy.value]
                    ])
                ])
            ]));
        };
    }
});
